import type { IAuthService } from "@/services/interfaces/IAuthService";
import type { AuthSession } from "@/lib/types";

const MOCK_DELAY_MS = 800;

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const MOCK_SESSION: AuthSession = {
  userId: "mock-user-123",
  email: "hunter@wexare.dev",
  displayName: "Mock Hunter",
  avatarUrl: null,
  walletAddress: "0xMOCK_WALLET_ADDRESS_1234",
  role: "user",
  createdAt: new Date().toISOString(),
};

const MOCK_WALLET_ADDRESS = "0xMOCK_WALLET_ADDRESS_1234";

export class MockAuthService implements IAuthService {
  private session: AuthSession | null = null;
  private listeners: Set<(session: AuthSession | null) => void> = new Set();

  async login(_provider: "google" | "apple" | "email"): Promise<AuthSession> {
    await delay(MOCK_DELAY_MS);
    this.session = { ...MOCK_SESSION, createdAt: new Date().toISOString() };
    this.notifyListeners();
    return this.session;
  }

  async logout(): Promise<void> {
    await delay(500);
    this.session = null;
    this.notifyListeners();
  }

  async getSession(): Promise<AuthSession | null> {
    await delay(300);
    return this.session;
  }

  async getWalletAddress(): Promise<string | null> {
    await delay(300);
    return this.session ? MOCK_WALLET_ADDRESS : null;
  }

  onAuthStateChange(
    callback: (session: AuthSession | null) => void,
  ): () => void {
    this.listeners.add(callback);
    return () => {
      this.listeners.delete(callback);
    };
  }

  private notifyListeners(): void {
    for (const listener of this.listeners) {
      listener(this.session);
    }
  }
}
